import { DEFAULT_WEB_LEAD_MODULE } from "../constants/webLeadModules";

export function getConsultationPath(module = DEFAULT_WEB_LEAD_MODULE) {
  const code = module || DEFAULT_WEB_LEAD_MODULE;
  return `/consultation?module=${encodeURIComponent(code)}`;
}
